import { ApiService } from 'services';
import { toastr } from 'react-redux-toastr';
import { handleException } from 'actions/exceptions';
import ScrollIntoView from 'common/App/ScrollIntoView';

export const ADD_NEW_BO_REQUEST = 'ADD_NEW_BO_REQUEST';
export const ADD_NEW_BO_SUCCESS = 'ADD_NEW_BO_SUCCESS';
export const ADD_NEW_BO_FAILURE = 'ADD_NEW_BO_FAILURE';

function requestAddNewBeneficialOwner() {
  return {
    type: ADD_NEW_BO_REQUEST,
    isAddingNewBeneficalOwner: true,
  };
}

function receiveAddNewBeneficialOwner(addNewRowContainer) {
  return {
    type: ADD_NEW_BO_SUCCESS,
    isAddingNewBeneficalOwner: false,
    newRowGuid: addNewRowContainer && addNewRowContainer.RowGuid,
    statementContainer: addNewRowContainer && addNewRowContainer.statementContainer
  };
}

function rejectAddNewBeneficialOwner() {
  return {
    type: ADD_NEW_BO_FAILURE,
    isAddingNewBeneficalOwner: false,
  };
}

export function addNewBeneficialOwner(accountId, parentGuid, isImylayer, isPooled) {
  return (dispatch) => {
    dispatch(requestAddNewBeneficialOwner());
    const promise = () => ApiService
      .addBeneficialOwner(accountId, parentGuid, isImylayer)
      .then((response) => {
        dispatch(receiveAddNewBeneficialOwner(response.data));
        if (isImylayer) {
          toastr.success('Save Successful', 'New IMY Tier successfully added');
        } else {
          toastr.success('Save Successful', `New ${ isPooled ? 'Pooled Account' : 'Beneficial Owner' } successfully added`);
        }

        const { rowGuid } = response.data;
        if (rowGuid) {
          ScrollIntoView(rowGuid);
        }
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectAddNewBeneficialOwner(), true));
        }
      });
    return promise();
  };
}
